const search = window.location.search;
const params = new URLSearchParams(search);
const uid = params.get('u');

export const url_identifier = uid;